/**
 * HemSyd Favoriter — ingen app, eget API (crevo.se/hemsyd-favorites).
 * Kräver window.HS_FAV_TOKEN + window.HS_FAV_API (satta av snippets/hs-fav-token.liquid).
 */
(function () {
  'use strict';

  var CACHE_KEY = 'hsFavIds';
  var loadedPromise = null;

  function getCachedIds() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setCachedIds(ids) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(ids));
    } catch (e) { /* ignore */ }
    dispatchChanged(ids.length);
  }

  function dispatchChanged(count) {
    document.dispatchEvent(new CustomEvent('hs:fav:changed', { detail: { count: count } }));
  }

  function loadFavoriteIds() {
    if (!window.HS_FAV_TOKEN) return Promise.resolve([]);

    var cached = getCachedIds();
    if (cached) return Promise.resolve(cached);

    if (loadedPromise) return loadedPromise;

    loadedPromise = fetch(window.HS_FAV_API + '/favorites/list.php?token=' + encodeURIComponent(window.HS_FAV_TOKEN))
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var ids = (json.ok && json.data && json.data.product_ids) || [];
        setCachedIds(ids);
        return ids;
      })
      .catch(function () { return []; });

    return loadedPromise;
  }

  /**
   * Togglar favorit. Anropas av hjärt-knappar överallt (produktkort, produktsida,
   * panelen, sidan "Mina favoriter"). Öppnar sido-panelen efter varje lyckad
   * togglering (både lägga till och ta bort) så användaren ser aktuell lista.
   */
  function toggleFavorite(productId, productHandle, btnEl, callback) {
    if (!window.HS_FAV_TOKEN) {
      var returnTo = window.location.pathname + window.location.search;
      window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(returnTo);
      return;
    }

    if (btnEl) btnEl.classList.add('is-loading');

    fetch(window.HS_FAV_API + '/favorites/toggle.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: window.HS_FAV_TOKEN,
        product_id: productId,
        product_handle: productHandle
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (btnEl) btnEl.classList.remove('is-loading');
        if (!json.ok) return;

        var favorited = json.data.favorited;
        document.querySelectorAll('[data-hs-fav-id="' + productId + '"]').forEach(function (el) {
          el.classList.toggle('is-favorited', favorited);
          el.setAttribute('aria-pressed', favorited ? 'true' : 'false');
        });

        var cached = getCachedIds() || [];
        if (favorited) {
          if (cached.indexOf(String(productId)) === -1) cached.push(String(productId));
        } else {
          cached = cached.filter(function (id) { return id !== String(productId); });
        }
        setCachedIds(cached);

        if (window.HSFavoritesDrawer) window.HSFavoritesDrawer.open();
        if (callback) callback(favorited);
      })
      .catch(function () {
        if (btnEl) btnEl.classList.remove('is-loading');
      });
  }

  function initButtons(root) {
    root = root || document;
    var buttons = root.querySelectorAll('[data-hs-fav-id]');
    if (!buttons.length) return;

    loadFavoriteIds().then(function (ids) {
      buttons.forEach(function (btn) {
        var id = btn.getAttribute('data-hs-fav-id');
        var isFav = ids.indexOf(String(id)) !== -1;
        btn.classList.toggle('is-favorited', isFav);
        btn.setAttribute('aria-pressed', isFav ? 'true' : 'false');
      });
    });

    buttons.forEach(function (btn) {
      if (btn.dataset.hsFavBound) return;
      btn.dataset.hsFavBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(btn.getAttribute('data-hs-fav-id'), btn.getAttribute('data-hs-fav-handle'), btn);
      });
    });
  }

  window.HSFavorites = {
    init: initButtons,
    loadIds: loadFavoriteIds,
    toggle: toggleFavorite
  };

  function bootstrap() {
    initButtons(document);
    loadFavoriteIds().then(function (ids) { dispatchChanged(ids.length); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Produktkort laddas ibland in via AJAX (t.ex. quickview, infinite scroll) —
  // exponera init() så sådan kod kan anropa window.HSFavorites.init(nyttElement).
})();
